import centroid from '@turf/centroid';
import { useRecoilState, useRecoilValue } from 'recoil';
import { DRAW_MODE_CIRCLE, DRAW_MODE_POLYGON } from '../../../constants/map';
import { editingDeliveryFenceState, selectedDeliveryFenceState } from '../../../storage/deliveryFences';
import { getAddressFromPoint } from '../../../utils/geocode';
import CoreDrawControls from './CoreDrawControls';

function DeliveryFenceDrawControls() {
  const deliveryFencePolygon = useRecoilValue(selectedDeliveryFenceState)?.polygon;
  const [editingDeliveryFence, setEditingDeliveryFence] = useRecoilState(editingDeliveryFenceState);

  return (
    <CoreDrawControls
      updateKey={editingDeliveryFence?._id}
      polygon={deliveryFencePolygon}
      updatedPolygon={editingDeliveryFence?.polygon}
      initialDrawMode={!editingDeliveryFence?._id ? DRAW_MODE_CIRCLE : DRAW_MODE_POLYGON}
      onUpdatePolygon={async (polygon) => {
        if (editingDeliveryFence) {
          setEditingDeliveryFence((prev) => ({ ...prev!, polygon }));
        }
      }}
      onUpdateGeoreference={async (point) => {
        if (editingDeliveryFence) {
          let address: string | undefined = '';
          if (point) {
            address = await getAddressFromPoint(point);
          }
          setEditingDeliveryFence((prev) => ({ ...prev!, geoReference: address }));
        }
      }}
      onUpdateGeoreferenceFromPolygon={async (polygon) => {
        if (editingDeliveryFence) {
          let address: string | undefined = '';
          if (polygon) {
            const center = centroid(polygon);
            const point = {
              lng: center.geometry.coordinates[0],
              lat: center.geometry.coordinates[1],
            };
            address = await getAddressFromPoint(point);
          }
          setEditingDeliveryFence((prev) => ({ ...prev!, geoReference: address }));
        }
      }}
    />
  );
}

export default DeliveryFenceDrawControls;
